import { render, staticRenderFns } from "./WarningOutlinedIcon.vue?vue&type=template&id=7ec40b49&"
import script from "./WarningOutlinedIcon.vue?vue&type=script&lang=js&"
export * from "./WarningOutlinedIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports